const decodeBase64Url = (value) => {
  if (!value) return null;

  try {
    const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), "=");
    return atob(padded);
  } catch (_error) {
    return null;
  }
};

export const getJwtPayload = () => {
  if (typeof window === "undefined") return null;

  const token = localStorage.getItem("token");
  if (!token || !token.includes(".")) return null;

  const payloadPart = token.split(".")[1];
  const decoded = decodeBase64Url(payloadPart);
  if (!decoded) return null;

  try {
    return JSON.parse(decoded);
  } catch (_error) {
    return null;
  }
};

export const getAdminPermissions = () => {
  if (typeof window === "undefined") {
    return {
      role: null,
      adminType: null,
      isAdmin: false,
      isSuperAdmin: false,
    };
  }

  const payload = getJwtPayload();
  const role = payload?.role || null;
  const tokenSuperFlag = payload?.isSuperAdmin;
  const adminType =
    localStorage.getItem("AdminType") ||
    localStorage.getItem("adminType") ||
    payload?.AdminType ||
    payload?.adminType ||
    null;
  const legacyIsAdmin = localStorage.getItem("IsAdmin");
  const legacySuperFlag = localStorage.getItem("IsSuper");
  const normalizedAdminType = String(adminType || "")
    .toLowerCase()
    .replace(/\s+/g, "")
    .replace(/_/g, "");
  const normalizedRole = (role || "").toLowerCase();

  const isAdmin =
    normalizedRole === "admin" ||
    normalizedRole === "superadmin" ||
    normalizedRole === "super_admin" ||
    legacyIsAdmin === "true" ||
    legacyIsAdmin === "1";
  const isSuperAdmin =
    normalizedRole === "superadmin" ||
    normalizedRole === "super_admin" ||
    tokenSuperFlag === true ||
    legacySuperFlag === "true" ||
    legacySuperFlag === "1" ||
    normalizedAdminType === "superadmin" ||
    normalizedAdminType === "supper" ||
    normalizedAdminType === "super";

  return {
    role,
    adminType,
    isAdmin,
    isSuperAdmin,
  };
};
